// Key code constants
// Available values for `KeyboardEvent.keyCode` attribute.
var KEY_CANCEL = 3;
var KEY_HELP = 6;
var KEY_BACK_SPACE = 8;
var KEY_TAB = 9;
var KEY_CLEAR = 12;
var KEY_RETURN = 13;
var KEY_SHIFT = 16;
var KEY_CONTROL = 17;
var KEY_ALT = 18;
var KEY_PAUSE = 19;
var KEY_CAPS_LOCK = 20;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_PAGE_UP = 33;
var KEY_PAGE_DOWN = 34;
var KEY_END = 35;
var KEY_HOME = 36;
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var KEY_PRINTSCREEN = 44;
var KEY_INSERT = 45;
var KEY_DELETE = 46;
var KEY_0 = 48;
var KEY_1 = 49;
var KEY_2 = 50;
var KEY_3 = 51;
var KEY_4 = 52;
var KEY_5 = 53;
var KEY_6 = 54;
var KEY_7 = 55;
var KEY_8 = 56;
var KEY_9 = 57;
var KEY_A = 65;
var KEY_B = 66;
var KEY_C = 67;
var KEY_D = 68;
var KEY_E = 69;
var KEY_F = 70;
var KEY_G = 71;
var KEY_H = 72;
var KEY_I = 73;
var KEY_J = 74;
var KEY_K = 75;
var KEY_L = 76;
var KEY_M = 77;
var KEY_N = 78;
var KEY_O = 79;
var KEY_P = 80;
var KEY_Q = 81;
var KEY_R = 82;
var KEY_S = 83;
var KEY_T = 84;
var KEY_U = 85;
var KEY_V = 86;
var KEY_W = 87;
var KEY_X = 88;
var KEY_Y = 89;
var KEY_Z = 90;
var KEY_LEFT_CMD = 91;
var KEY_RIGHT_CMD = 92;
var KEY_CONTEXT_MENU = 93;
var KEY_NUMPAD0 = 96;
var KEY_NUMPAD1 = 97;
var KEY_NUMPAD2 = 98;
var KEY_NUMPAD3 = 99;
var KEY_NUMPAD4 = 100;
var KEY_NUMPAD5 = 101;
var KEY_NUMPAD6 = 102;
var KEY_NUMPAD7 = 103;
var KEY_NUMPAD8 = 104;
var KEY_NUMPAD9 = 105;
var KEY_MULTIPLY = 106;
var KEY_ADD = 107;
var KEY_SUBTRACT = 109;
var KEY_DECIMAL = 110;
var KEY_DIVIDE = 111;
var KEY_F1 = 112;
var KEY_F2 = 113;
var KEY_F3 = 114;
var KEY_F4 = 115;
var KEY_F5 = 116;
var KEY_F6 = 117;
var KEY_F7 = 118;
var KEY_F8 = 119;
var KEY_F9 = 120;
var KEY_F10 = 121;
var KEY_F11 = 122;
var KEY_F12 = 123;
var KEY_F13 = 124;
var KEY_F14 = 125;
var KEY_F15 = 126;
var KEY_F16 = 127;
var KEY_F17 = 128;
var KEY_F18 = 129;
var KEY_F19 = 130;
var KEY_F20 = 131;
var KEY_F21 = 132;
var KEY_F22 = 133;
var KEY_F23 = 134;
var KEY_F24 = 135;
var KEY_NUM_LOCK = 144;
var KEY_SCROLL_LOCK = 145;
var KEY_SEMICOLON = 186;
var KEY_EQUALS = 187;
var KEY_COMMA = 188;
var KEY_DASH = 189;
var KEY_PERIOD = 190;
var KEY_SLASH = 191;
var KEY_BACK_QUOTE = 192;
var KEY_OPEN_BRACKET = 219;
var KEY_BACK_SLASH = 220;
var KEY_CLOSE_BRACKET = 221;
var KEY_QUOTE = 222;
// Key code constants specific to firefox only.
var KEY_FIREFOX_ENTER = 14;
var KEY_FIREFOX_SEMICOLON = 59;
var KEY_FIREFOX_EQUALS = 61;
var KEY_FIREFOX_SEPARATOR = 108;
var KEY_FIREFOX_META = 224;
// Key values constants
// Available values for `KeyboardEvent.key` attribute.
var VALUE_CANCEL = 'Cancel';
var VALUE_HELP = 'Help';
var VALUE_BACK_SPACE = 'Backspace';
var VALUE_TAB = 'Tab';
var VALUE_CLEAR = 'Clear';
var VALUE_ENTER = 'Enter';
var VALUE_RETURN = 'Enter';
var VALUE_SHIFT = 'Shift';
var VALUE_CONTROL = 'Control';
var VALUE_ALT = 'Alt';
var VALUE_PAUSE = 'Pause';
var VALUE_CAPS_LOCK = 'CapsLock';
var VALUE_ESCAPE = 'Escape';
var VALUE_SPACE = ' ';
var VALUE_PAGE_UP = 'PageUp';
var VALUE_PAGE_DOWN = 'PageDown';
var VALUE_END = 'End';
var VALUE_HOME = 'Home';
var VALUE_LEFT = 'ArrowLeft';
var VALUE_UP = 'ArrowUp';
var VALUE_RIGHT = 'ArrowRight';
var VALUE_DOWN = 'ArrowDown';
var VALUE_PRINTSCREEN = 'PrintScreen';
var VALUE_INSERT = 'Insert';
var VALUE_DELETE = 'Delete';
var VALUE_0 = '0';
var VALUE_1 = '1';
var VALUE_2 = '2';
var VALUE_3 = '3';
var VALUE_4 = '4';
var VALUE_5 = '5';
var VALUE_6 = '6';
var VALUE_7 = '7';
var VALUE_8 = '8';
var VALUE_9 = '9';
var VALUE_A = 'a';
var VALUE_B = 'b';
var VALUE_C = 'c';
var VALUE_D = 'd';
var VALUE_E = 'e';
var VALUE_F = 'f';
var VALUE_G = 'g';
var VALUE_H = 'h';
var VALUE_I = 'i';
var VALUE_J = 'j';
var VALUE_K = 'k';
var VALUE_L = 'l';
var VALUE_M = 'm';
var VALUE_N = 'n';
var VALUE_O = 'o';
var VALUE_P = 'p';
var VALUE_Q = 'q';
var VALUE_R = 'r';
var VALUE_S = 's';
var VALUE_T = 't';
var VALUE_U = 'u';
var VALUE_V = 'v';
var VALUE_W = 'w';
var VALUE_X = 'x';
var VALUE_Y = 'y';
var VALUE_Z = 'z';
var VALUE_META = 'Meta';
var VALUE_LEFT_CMD = 'Meta';
var VALUE_RIGHT_CMD = 'Meta';
var VALUE_CONTEXT_MENU = 'ContextMenu';
var VALUE_NUMPAD0 = '0';
var VALUE_NUMPAD1 = '1';
var VALUE_NUMPAD2 = '2';
var VALUE_NUMPAD3 = '3';
var VALUE_NUMPAD4 = '4';
var VALUE_NUMPAD5 = '5';
var VALUE_NUMPAD6 = '6';
var VALUE_NUMPAD7 = '7';
var VALUE_NUMPAD8 = '8';
var VALUE_NUMPAD9 = '9';
var VALUE_MULTIPLY = '*';
var VALUE_ADD = '+';
var VALUE_SUBTRACT = '-';
var VALUE_DECIMAL = '.';
var VALUE_DIVIDE = '/';
var VALUE_F1 = 'F1';
var VALUE_F2 = 'F2';
var VALUE_F3 = 'F3';
var VALUE_F4 = 'F4';
var VALUE_F5 = 'F5';
var VALUE_F6 = 'F6';
var VALUE_F7 = 'F7';
var VALUE_F8 = 'F8';
var VALUE_F9 = 'F9';
var VALUE_F10 = 'F10';
var VALUE_F11 = 'F11';
var VALUE_F12 = 'F12';
var VALUE_F13 = 'F13';
var VALUE_F14 = 'F14';
var VALUE_F15 = 'F15';
var VALUE_F16 = 'F16';
var VALUE_F17 = 'F17';
var VALUE_F18 = 'F18';
var VALUE_F19 = 'F19';
var VALUE_F20 = 'F20';
var VALUE_F21 = 'F21';
var VALUE_F22 = 'F22';
var VALUE_F23 = 'F23';
var VALUE_F24 = 'F24';
var VALUE_NUM_LOCK = 'NumLock';
var VALUE_SCROLL_LOCK = 'ScrollLock';
var VALUE_SEMICOLON = ';';
var VALUE_EQUALS = '=';
var VALUE_COMMA = ',';
var VALUE_DASH = '-';
var VALUE_PERIOD = '.';
var VALUE_SLASH = '/';
var VALUE_BACK_QUOTE = '`';
var VALUE_OPEN_BRACKET = '[';
var VALUE_BACK_SLASH = '\\';
var VALUE_CLOSE_BRACKET = ']';
var VALUE_QUOTE = "'";
// Key code constants
// Available values for `KeyboardEvent.code` attribute.
var CODE_UNIDENTIFIED = 'Unidentified';
var CODE_ESCAPE = 'Escape';
var CODE_MINUS = 'Minus';
var CODE_DASH = 'Minus';
var CODE_EQUALS = 'Equal';
var CODE_BACK_SPACE = 'Backspace';
var CODE_TAB = 'Tab';
var CODE_ENTER = 'Enter';
var CODE_RETURN = 'Enter';
var CODE_SHIFT_LEFT = 'ShiftLeft';
var CODE_SHIFT_RIGHT = 'ShiftRight';
var CODE_CONTROL_LEFT = 'ControlLeft';
var CODE_CONTROL_RIGHT = 'ControlRight';
var CODE_ALT_LEFT = 'AltLeft';
var CODE_ALT_RIGHT = 'AltRight';
var CODE_PAUSE = 'Pause';
var CODE_CAPS_LOCK = 'CapsLock';
var CODE_SPACE = 'Space';
var CODE_PAGE_UP = 'PageUp';
var CODE_PAGE_DOWN = 'PageDown';
var CODE_END = 'End';
var CODE_HOME = 'Home';
var CODE_LEFT = 'ArrowLeft';
var CODE_UP = 'ArrowUp';
var CODE_RIGHT = 'ArrowRight';
var CODE_DOWN = 'ArrowDown';
var CODE_PRINTSCREEN = 'PrintScreen';
var CODE_INSERT = 'Insert';
var CODE_DELETE = 'Delete';
var CODE_0 = 'Digit0';
var CODE_1 = 'Digit1';
var CODE_2 = 'Digit2';
var CODE_3 = 'Digit3';
var CODE_4 = 'Digit4';
var CODE_5 = 'Digit5';
var CODE_6 = 'Digit6';
var CODE_7 = 'Digit7';
var CODE_8 = 'Digit8';
var CODE_9 = 'Digit9';
var CODE_A = 'KeyA';
var CODE_B = 'KeyB';
var CODE_C = 'KeyC';
var CODE_D = 'KeyD';
var CODE_E = 'KeyE';
var CODE_F = 'KeyF';
var CODE_G = 'KeyG';
var CODE_H = 'KeyH';
var CODE_I = 'KeyI';
var CODE_J = 'KeyJ';
var CODE_K = 'KeyK';
var CODE_L = 'KeyL';
var CODE_M = 'KeyM';
var CODE_N = 'KeyN';
var CODE_O = 'KeyO';
var CODE_P = 'KeyP';
var CODE_Q = 'KeyQ';
var CODE_R = 'KeyR';
var CODE_S = 'KeyS';
var CODE_T = 'KeyT';
var CODE_U = 'KeyU';
var CODE_V = 'KeyV';
var CODE_W = 'KeyW';
var CODE_X = 'KeyX';
var CODE_Y = 'KeyY';
var CODE_Z = 'KeyZ';
var CODE_META_LEFT = 'MetaLeft';
var CODE_OS_LEFT = 'OSLeft';
var CODE_META_RIGHT = 'MetaRight';
var CODE_OS_RIGHT = 'OSRight';
var CODE_CONTEXT_MENU = 'ContextMenu';
var CODE_NUMPAD0 = 'Numpad0';
var CODE_NUMPAD1 = 'Numpad1';
var CODE_NUMPAD2 = 'Numpad2';
var CODE_NUMPAD3 = 'Numpad3';
var CODE_NUMPAD4 = 'Numpad4';
var CODE_NUMPAD5 = 'Numpad5';
var CODE_NUMPAD6 = 'Numpad6';
var CODE_NUMPAD7 = 'Numpad7';
var CODE_NUMPAD8 = 'Numpad8';
var CODE_NUMPAD9 = 'Numpad9';
var CODE_NUMPAD_MULTIPLY = 'NumpadMultiply';
var CODE_NUMPAD_ADD = 'NumpadAdd';
var CODE_NUMPAD_SUBTRACT = 'NumpadSubtract';
var CODE_NUMPAD_DECIMAL = 'NumpadDecimal';
var CODE_NUMPAD_DIVIDE = 'NumpadDivide';
var CODE_NUMPAD_ENTER = 'NumpadEnter';
var CODE_F1 = 'F1';
var CODE_F2 = 'F2';
var CODE_F3 = 'F3';
var CODE_F4 = 'F4';
var CODE_F5 = 'F5';
var CODE_F6 = 'F6';
var CODE_F7 = 'F7';
var CODE_F8 = 'F8';
var CODE_F9 = 'F9';
var CODE_F10 = 'F10';
var CODE_F11 = 'F11';
var CODE_F12 = 'F12';
var CODE_F13 = 'F13';
var CODE_F14 = 'F14';
var CODE_F15 = 'F15';
var CODE_F16 = 'F16';
var CODE_F17 = 'F17';
var CODE_F18 = 'F18';
var CODE_F19 = 'F19';
var CODE_F20 = 'F20';
var CODE_F21 = 'F21';
var CODE_F22 = 'F22';
var CODE_F23 = 'F23';
var CODE_F24 = 'F24';
var CODE_NUM_LOCK = 'NumLock';
var CODE_SCROLL_LOCK = 'ScrollLock';
var CODE_SEMICOLON = 'Semicolon';
var CODE_COMMA = 'Comma';
var CODE_PERIOD = 'Period';
var CODE_SLASH = 'Slash';
var CODE_BACK_QUOTE = 'Backquote';
var CODE_OPEN_BRACKET = 'BracketLeft';
var CODE_BACK_SLASH = 'Backslash';
var CODE_CLOSE_BRACKET = 'BracketRight';
var CODE_QUOTE = 'Quote';

export { CODE_0, CODE_1, CODE_2, CODE_3, CODE_4, CODE_5, CODE_6, CODE_7, CODE_8, CODE_9, CODE_A, CODE_ALT_LEFT, CODE_ALT_RIGHT, CODE_B, CODE_BACK_QUOTE, CODE_BACK_SLASH, CODE_BACK_SPACE, CODE_C, CODE_CAPS_LOCK, CODE_CLOSE_BRACKET, CODE_COMMA, CODE_CONTEXT_MENU, CODE_CONTROL_LEFT, CODE_CONTROL_RIGHT, CODE_D, CODE_DASH, CODE_DELETE, CODE_DOWN, CODE_E, CODE_END, CODE_ENTER, CODE_EQUALS, CODE_ESCAPE, CODE_F, CODE_F1, CODE_F10, CODE_F11, CODE_F12, CODE_F13, CODE_F14, CODE_F15, CODE_F16, CODE_F17, CODE_F18, CODE_F19, CODE_F2, CODE_F20, CODE_F21, CODE_F22, CODE_F23, CODE_F24, CODE_F3, CODE_F4, CODE_F5, CODE_F6, CODE_F7, CODE_F8, CODE_F9, CODE_G, CODE_H, CODE_HOME, CODE_I, CODE_INSERT, CODE_J, CODE_K, CODE_L, CODE_LEFT, CODE_M, CODE_META_LEFT, CODE_META_RIGHT, CODE_MINUS, CODE_N, CODE_NUMPAD0, CODE_NUMPAD1, CODE_NUMPAD2, CODE_NUMPAD3, CODE_NUMPAD4, CODE_NUMPAD5, CODE_NUMPAD6, CODE_NUMPAD7, CODE_NUMPAD8, CODE_NUMPAD9, CODE_NUMPAD_ADD, CODE_NUMPAD_DECIMAL, CODE_NUMPAD_DIVIDE, CODE_NUMPAD_ENTER, CODE_NUMPAD_MULTIPLY, CODE_NUMPAD_SUBTRACT, CODE_NUM_LOCK, CODE_O, CODE_OPEN_BRACKET, CODE_OS_LEFT, CODE_OS_RIGHT, CODE_P, CODE_PAGE_DOWN, CODE_PAGE_UP, CODE_PAUSE, CODE_PERIOD, CODE_PRINTSCREEN, CODE_Q, CODE_QUOTE, CODE_R, CODE_RETURN, CODE_RIGHT, CODE_S, CODE_SCROLL_LOCK, CODE_SEMICOLON, CODE_SHIFT_LEFT, CODE_SHIFT_RIGHT, CODE_SLASH, CODE_SPACE, CODE_T, CODE_TAB, CODE_U, CODE_UNIDENTIFIED, CODE_UP, CODE_V, CODE_W, CODE_X, CODE_Y, CODE_Z, KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6, KEY_7, KEY_8, KEY_9, KEY_A, KEY_ADD, KEY_ALT, KEY_B, KEY_BACK_QUOTE, KEY_BACK_SLASH, KEY_BACK_SPACE, KEY_C, KEY_CANCEL, KEY_CAPS_LOCK, KEY_CLEAR, KEY_CLOSE_BRACKET, KEY_COMMA, KEY_CONTEXT_MENU, KEY_CONTROL, KEY_D, KEY_DASH, KEY_DECIMAL, KEY_DELETE, KEY_DIVIDE, KEY_DOWN, KEY_E, KEY_END, KEY_EQUALS, KEY_ESCAPE, KEY_F, KEY_F1, KEY_F10, KEY_F11, KEY_F12, KEY_F13, KEY_F14, KEY_F15, KEY_F16, KEY_F17, KEY_F18, KEY_F19, KEY_F2, KEY_F20, KEY_F21, KEY_F22, KEY_F23, KEY_F24, KEY_F3, KEY_F4, KEY_F5, KEY_F6, KEY_F7, KEY_F8, KEY_F9, KEY_FIREFOX_ENTER, KEY_FIREFOX_EQUALS, KEY_FIREFOX_META, KEY_FIREFOX_SEMICOLON, KEY_FIREFOX_SEPARATOR, KEY_G, KEY_H, KEY_HELP, KEY_HOME, KEY_I, KEY_INSERT, KEY_J, KEY_K, KEY_L, KEY_LEFT, KEY_LEFT_CMD, KEY_M, KEY_MULTIPLY, KEY_N, KEY_NUMPAD0, KEY_NUMPAD1, KEY_NUMPAD2, KEY_NUMPAD3, KEY_NUMPAD4, KEY_NUMPAD5, KEY_NUMPAD6, KEY_NUMPAD7, KEY_NUMPAD8, KEY_NUMPAD9, KEY_NUM_LOCK, KEY_O, KEY_OPEN_BRACKET, KEY_P, KEY_PAGE_DOWN, KEY_PAGE_UP, KEY_PAUSE, KEY_PERIOD, KEY_PRINTSCREEN, KEY_Q, KEY_QUOTE, KEY_R, KEY_RETURN, KEY_RIGHT, KEY_RIGHT_CMD, KEY_S, KEY_SCROLL_LOCK, KEY_SEMICOLON, KEY_SHIFT, KEY_SLASH, KEY_SPACE, KEY_SUBTRACT, KEY_T, KEY_TAB, KEY_U, KEY_UP, KEY_V, KEY_W, KEY_X, KEY_Y, KEY_Z, VALUE_0, VALUE_1, VALUE_2, VALUE_3, VALUE_4, VALUE_5, VALUE_6, VALUE_7, VALUE_8, VALUE_9, VALUE_A, VALUE_ADD, VALUE_ALT, VALUE_B, VALUE_BACK_QUOTE, VALUE_BACK_SLASH, VALUE_BACK_SPACE, VALUE_C, VALUE_CANCEL, VALUE_CAPS_LOCK, VALUE_CLEAR, VALUE_CLOSE_BRACKET, VALUE_COMMA, VALUE_CONTEXT_MENU, VALUE_CONTROL, VALUE_D, VALUE_DASH, VALUE_DECIMAL, VALUE_DELETE, VALUE_DIVIDE, VALUE_DOWN, VALUE_E, VALUE_END, VALUE_ENTER, VALUE_EQUALS, VALUE_ESCAPE, VALUE_F, VALUE_F1, VALUE_F10, VALUE_F11, VALUE_F12, VALUE_F13, VALUE_F14, VALUE_F15, VALUE_F16, VALUE_F17, VALUE_F18, VALUE_F19, VALUE_F2, VALUE_F20, VALUE_F21, VALUE_F22, VALUE_F23, VALUE_F24, VALUE_F3, VALUE_F4, VALUE_F5, VALUE_F6, VALUE_F7, VALUE_F8, VALUE_F9, VALUE_G, VALUE_H, VALUE_HELP, VALUE_HOME, VALUE_I, VALUE_INSERT, VALUE_J, VALUE_K, VALUE_L, VALUE_LEFT, VALUE_LEFT_CMD, VALUE_M, VALUE_META, VALUE_MULTIPLY, VALUE_N, VALUE_NUMPAD0, VALUE_NUMPAD1, VALUE_NUMPAD2, VALUE_NUMPAD3, VALUE_NUMPAD4, VALUE_NUMPAD5, VALUE_NUMPAD6, VALUE_NUMPAD7, VALUE_NUMPAD8, VALUE_NUMPAD9, VALUE_NUM_LOCK, VALUE_O, VALUE_OPEN_BRACKET, VALUE_P, VALUE_PAGE_DOWN, VALUE_PAGE_UP, VALUE_PAUSE, VALUE_PERIOD, VALUE_PRINTSCREEN, VALUE_Q, VALUE_QUOTE, VALUE_R, VALUE_RETURN, VALUE_RIGHT, VALUE_RIGHT_CMD, VALUE_S, VALUE_SCROLL_LOCK, VALUE_SEMICOLON, VALUE_SHIFT, VALUE_SLASH, VALUE_SPACE, VALUE_SUBTRACT, VALUE_T, VALUE_TAB, VALUE_U, VALUE_UP, VALUE_V, VALUE_W, VALUE_X, VALUE_Y, VALUE_Z };
